// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"359":"ad3b8a78","644":"6b18ae9c","691":"b609784c","996":"4bcfecb5"}[chunkId] + ".css";
};